import React from "react";
import { NavLink } from "react-router-dom";

const LINKS = [
  { label: "Current openings", to: "/careers", end: true },
  { label: "How we hire", to: "/careers/how-we-hire" },
  { label: "Life at Nirkana", to: "/careers/life-at-nirkana" },
  { label: "Benefits", to: "/careers/benefits" },
  { label: "FAQ", to: "/careers/faq" },
];

const CareersSubNav = () => {
  return (
    <div className="border-b border-line bg-paper">
      <div className="max-w-content mx-auto flex gap-6 overflow-x-auto px-6 lg:px-10">
        {LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) =>
              `whitespace-nowrap border-b-2 py-4 text-sm font-medium transition-colors ${
                isActive
                  ? "border-action text-brand"
                  : "border-transparent text-muted hover:text-charcoal"
              }`
            }
          >
            {link.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default CareersSubNav;
